import React, { useState ,useEffect} from 'react';
import { fetchThread } from '../../../util/feedback_util';
import { feedbackFileUrl } from '../../../util/file_url';
import ImageDisplay from '../Work Instructions/Author/AttachmentsDisplay/ImageDisplay'
import moment from 'moment';
import AttachmentModal from './AttachmentModal';
const FeedbackMessages = ({ feedbackObjects, currentUser,addMessageToThread,threadId}) => {

  const [newMessage, setNewMessage] = useState('');
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [messages, setMessages] = useState(feedbackObjects || []);
  const [messageList, setMessageList] = useState([]);
  const [showAttachmentModal, setShowAttachmentModal] = useState(false);
  const [selectedAttachment, setSelectedAttachment] = useState(null);
  const [selectedFeedback, setSelectedFeedback] = useState(null);
  const handleSubmit = (e) => {
    e.preventDefault();
    
    addMessageToThread(newMessage,selectedFiles)
    setNewMessage('');
    setSelectedFiles([])
  };

    useEffect(() => {
      setMessages(feedbackObjects)
      const timerFunction = () => {
        console.log('30 seconds have passed');
        fetchThread(threadId).then((res) => {
          setMessages(res[0].Feedback );
        });
      };
      timerFunction();
      const intervalId = setInterval(timerFunction, 30000); 
      return () => clearInterval(intervalId);
    }, []); 

    useEffect(() => {
      setMessages(feedbackObjects)
    }, [feedbackObjects]);
  

  const removeFile = (indexToRemove) => {
    setSelectedFiles(prevFiles => {
      const toRemove = prevFiles[indexToRemove];
      if (toRemove && toRemove.previewUrl) {
        try { URL.revokeObjectURL(toRemove.previewUrl); } catch {}
      }
      return prevFiles.filter((_, index) => index !== indexToRemove)
    });
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const allowed = files.filter(f => (
      f.type && (f.type.startsWith('image/') || f.type.startsWith('video/') || f.type.startsWith('audio/'))
    ));
    const invalid = files.filter(f => !allowed.includes(f));

    if (invalid.length > 0) {
      alert(
        "Supported file types:\n" +
        "- Images: jpg, jpeg, png, gif, webp, bmp, svg\n" +
        "- Video: mp4 (H.264/AAC), webm (VP8/VP9/Opus), ogg\n" +
        "- Audio: mp3, wav, ogg/oga, m4a/aac, opus"
      );
    }

    let size = 0
    allowed.forEach(file => { size += file.size })

    if (size > 1024 * 1024 * 25 || allowed.length > 5) {
      alert("You can only upload 25MB of files and 5 files at a time")
      return
    }
    if (allowed.length === 0) return;
    const prepared = allowed.map(f => {
      if (!f.previewUrl) {
        try { f.previewUrl = URL.createObjectURL(f); } catch {}
      }
      return f;
    });
    setSelectedFiles(prevFiles => [...prevFiles, ...prepared]);
  };

  const handleAttachmentClick = (attachment, feedback) => {
    setSelectedAttachment(attachment);
    setSelectedFeedback(feedback);
    setShowAttachmentModal(true);
  };

  const closeAttachmentModal = () => {
    setShowAttachmentModal(false);
    setSelectedAttachment(null);
    setSelectedFeedback(null);
  };  

  const renderFilePreview = (wip_id, file, feedback) => {
    // Image files

    let src = wip_id
      ? feedbackFileUrl(file)
      : (file.previewUrl || "");
    if (file.type.startsWith('image/')) {
          return (
            <img 
            src={src}  
              style={{ maxWidth: '100px', maxHeight: '100px', cursor: 'pointer' }} 
              onClick={() => handleAttachmentClick(file, feedback)}
            />
           );
    }
    // Video files
    if (file.type.startsWith('video/')) {
      return (
        <video 
          src={src}
          preload="metadata"
          style={{ maxWidth: '200px', cursor: 'pointer' }}
          onClick={() => handleAttachmentClick(file, feedback)}
        >
          Your browser does not support the video element.
        </video>
      );
    }
  
    // Audio files
    if (file.type.startsWith('audio/')) {
      return (
        <audio 
          src={src} 
          controls
          style={{ maxWidth: '200px' }}
        >
          Your browser does not support the audio element.
        </audio>
      );
    }
  
    // PDF files
    if (file.type === 'application/pdf') {
      return (
        <div className="file-icon pdf" style={{ cursor: 'pointer' }} onClick={() => handleAttachmentClick(file, feedback)}>
          <i className="far fa-file-pdf"></i>
          <span>{file.name}</span>
        </div>
      );
    }
  
    // Default for other file types
    return (
      <div className="file-icon" style={{ cursor: 'pointer' }} onClick={() => handleAttachmentClick(file, feedback)}>
        <i className="far fa-file"></i>
        <span>{file.name}</span>
      </div>
    );
  };

  const renderMessage = (feedback,file,index,message) => {
    return <div key={feedback.__id } className={`message ${feedback.username === currentUser ? 'right' : 'left'}`}> 
              <div className="message-content">

              {file ? <div key={`file-${index}`} className="file-item">
                {renderFilePreview(feedback.wip_id, file, feedback)}
              </div> : null}
            
              {message ? <p>{feedback.message}</p>: null}

                <div className="message-header">
                   <small className="username">{feedback.username  }</small>
                   <small className="timestamp">{moment.utc(feedback.date).local(true).format("MM/DD/YYYY hh:mm A")}</small>
                   {/* <small className="timestamp">{feedback.date}</small> */}
                </div>
              </div>
            </div>
           
  }

  const renderMessageList = () => {
        let ml = messageList
        
          messages.sort((a, b) => new Date(a.date) - new Date(b.date))
          .map((feedback) => {
            
            if(feedback.Attachments.length > 0){
              feedback.Attachments.map((file, index) => {
                ml.push(renderMessage(feedback,file,index,null))
             })
            }
          
    
            if(feedback.message && feedback.message.trim() !== '' ){  
              ml.push(renderMessage(feedback,null,null,feedback.message))             
            }
            
          })
        setMessageList(ml)
  }
          
   

  return (
       <div className="feedback-messages" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
          <div className="message-list" style={{ flex: 1, overflowY: 'auto' }}>

        
            {messages.length > 0 ? messages
              .sort((a, b) => new Date(a.date) - new Date(b.date))
              .map((feedback) => {
                let ml = []
                if(feedback.Attachments.length > 0){
                  feedback.Attachments.map((file, index) => {
                    ml.push(renderMessage(feedback,file,index,null))
                })
                }
              
                if(feedback.message && feedback.message.trim() !== '' ){  
                  ml.push(renderMessage(feedback,null,null,feedback.message))             
                }
                return ml
              }) : null}

          </div> 

          {selectedFiles.length > 0 && (
            <div className="file-preview message-content" style={{ maxHeight: '20%', overflowY: 'auto' }}>
              {selectedFiles.map((file, index) => (
                <div key={index} className="file-item">
                  {renderFilePreview(null, file, null)}
                  <button className="remove-file-btn" onClick={() => removeFile(index)}></button> 
                </div>
              ))}
            </div>
          )}

          <form onSubmit={handleSubmit} className="message-input" style={{ marginTop: 'auto' }}>
            <input
              type="text"
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              placeholder="Type a message..."
            />
            <button 
              type="button" 
              onClick={() => document.getElementById('file-input').click()}
              className="button clickable"
              style={{margin:"0 1.25em 0 1.25em",width:"55.14px"}}
            >
              <input
                type="file"
                multiple
                accept="image/*, video/*, audio/*"
                onChange={handleFileChange}
                style={{ display: 'none' }}
                id="file-input"
              />
              Files
            </button>
            <button className="clickable" type="submit">Send</button>
          </form>

          {showAttachmentModal && (
            <AttachmentModal
              closeModal={closeAttachmentModal}
              attachment={selectedAttachment}
              feedback={selectedFeedback}
            />
          )}
        </div>
  );

};

export default FeedbackMessages;